import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../features/AuthContext';
import styles from '../styles/sidebar.module.css';

const Sidebar = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const displayName = user
        ? [user.nombre, user.apellido].filter(Boolean).join(' ') || user.email || 'Usuario'
        : 'Admin';
    const initials = displayName
        .split(' ')
        .map((s) => s[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
    const avatarSrc = user?.img_profile || null;

    const handleLogout = async () => {
        await logout();
        navigate('/login', { replace: true });
    };

    return (
        <aside className={styles.sidebar}>
            <div className={styles.brand}>
                <img src="/logo-largo.png" alt="Instituto 8" className={styles.logoImage} />
            </div>

            <nav className={styles.nav}>
                <div className={styles.navList}>
                    <NavLink to="/dashboard" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                            <polyline points="9 22 9 12 15 12 15 22" />
                        </svg>
                        Inicio
                    </NavLink>
                    <NavLink to="/covisage" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                            <polyline points="22,6 12,13 2,6" />
                        </svg>
                        Covisage
                    </NavLink>
                    <NavLink to="/systemic" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                        </svg>
                        Systemic Survey
                    </NavLink>
                    <NavLink to="/creatividades" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                            <polyline points="3.29 7 12 12 20.71 7"></polyline>
                            <line x1="12" y1="22" x2="12" y2="12"></line>
                        </svg>
                        4 Creatividades
                    </NavLink>
                    <NavLink to="/creative-leadership" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
                        <svg className={styles.icon} viewBox="96 96 320 320" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M405 255 A149 149 0 1 1 362 150"
                                stroke="currentColor"
                                strokeWidth="22"
                                strokeLinecap="round"
                            />
                            <path
                                d="M355 126 L399 151 L370 193"
                                stroke="currentColor"
                                strokeWidth="22"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <text
                                x="256"
                                y="292"
                                textAnchor="middle"
                                fontFamily="Arial, Helvetica, sans-serif"
                                fontSize="105"
                                fontWeight="700"
                                fill="currentColor"
                            >360°</text>
                        </svg>
                        360º Creative Leadership
                    </NavLink>
                </div>
            </nav>

            <div className={styles.footer}>
                <div className={styles.userProfile}>
                    {avatarSrc ? (
                        <img src={avatarSrc} alt="" className={styles.avatarImg} />
                    ) : (
                        <div className={styles.avatar}>{initials}</div>
                    )}
                    <div className={styles.userInfo}>
                        <span className={styles.userName}>{displayName}</span>
                        <span className={styles.userRole}>{user?.rol === 'administrador' ? 'Administrador' : 'Superuser'}</span>
                    </div>
                </div>
                <button type="button" onClick={handleLogout} className={styles.logoutBtn} title="Cerrar sesión">
                    <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                        <polyline points="16 17 21 12 16 7" />
                        <line x1="21" y1="12" x2="9" y2="12" />
                    </svg>
                    Salir
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;
